import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';
import { CustomValidatorsModule } from './pages/A2-utils/custom-validators/custom-validators.module';
import { AdministrationModule } from './pages/administration/administration.module';
import { AutoroutingModule } from './pages/autorouting/autorouting.module';
import { BillingGeneralModule } from './pages/billing-general/billing-general.module';
import { ComplaintsModule } from './pages/complaints/complaints.module';
import { CountyModule } from './pages/county/county.module';
import { DashboardClaimsModule } from './pages/dashboard-claims/dashboard-claims.module';
import { DriverScheduleModule } from './pages/driver-schedule/driver-schedule.module';
import { EscalationsModule } from './pages/escalations/escalations.module';
import { LicensesModule } from './pages/licenses/licenses.module';
import { ManagerReportsModule } from './pages/manager-reports/manager-reports.module';
import { PagesRoutingModule } from './pages/pages-routing.module';
import { PopupDriverScheduleModule } from './pages/popup-driver-schedule/popup-driver-schedule.module';
import { ProvidersBillingModule } from './pages/providers-billing/providers-billing.module';
import { StandingOrderModule } from './pages/standing-order/standing-order.module';
import { TrackerModule } from './pages/tracker/tracker.module';
import { CustomPreloadingService } from './services/custom-preloading.service';
import { T2TemplateBasicComponent } from './trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { DashboardProvidersModule } from './pages/dashboard-providers/dashboard-providers.module';
import { BillingProviderModule } from './pages/billing-provider/billing-provider.module';
import { ExternalBillingModule } from './pages/external-billing/external-billing.module';
import { DebugerAppModule } from './pages/A2-utils/debuger-app/debuger-app.module';
import { QuizModule } from './pages/quiz/quiz.module';
import { ZipCodeFloridaModule } from './pages/zip-code-florida/zip-code-florida.module';
import { DashboardProvidersExternalModule } from './pages/dashboard-providers-external/dashboard-providers-external.module';
import { CompaniesRescuenetModule } from './pages/companies-rescuenet/companies-rescuenet.module';


const routes = [
  {
    path: 'public',
    loadChildren: 'app/public/public.module#PublicModule',
    data: {
      preload: true
    }
  },
  {
    path: 'auth',
    loadChildren: 'app/pages/login/login.module#LoginModule',
    data: {
      preload: true
    }
  },
  {
    path: 'login/:token',
    loadChildren: 'app/pages/external-authentication/external-authentication.module#ExternalAuthenticationModule',
  },
  {
    path: 'login/error/:message',
    loadChildren: 'app/pages/external-authentication-error/external-authentication-error.module#ExternalAuthenticationErrorModule',
  },
  {
    path: 'confirmTrip/:code',
    loadChildren: 'app/pages/confirmTrip/confirmTrip.module#ConfirmTripModule'
  },
  {
    path: 'unsubscribe/:code',
    loadChildren: 'app/pages/unsubscribe/unsubscribe.module#UnsubscribeModule'
  },
  {
    path: 'billing',
    loadChildren: 'app/pages/billing-provider/billing-provider.module#BillingProviderModule'

  },
  {
    path: 'pages',
    component: T2TemplateBasicComponent,
    children: [
      {
        path: 'tripAuthorization',
        loadChildren: 'app/pages/trip-authorization/trip-authorization.module#TripAuthorizationModule'
      },
      {
        path: 'tripVip',
        loadChildren: 'app/pages/trip-vip/vip.module#VipModule'
      },
      {
        path: 'billingmodule',
        loadChildren: 'app/pages/external-billing/external-billing.module#ExternalBillingModule',
      },
      {
        path: 'administration',
        children: [
          {
            path: 'settings',
            children: [
              {
                path: 'valueMapping',
                loadChildren:
                  'app/pages/value-mapping/value-mapping.module#ValueMappingModule',
              },
            ],
          },
          {
          path: 'settings',
          loadChildren: 'app/pages/mail-template/mail-template.module#MailTemplateModule'
        },
          {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/service-provider/service-provider.module#ServiceProviderModule'
          },
          {
            path: 'settings',
            loadChildren: 'app/pages/messages/messages.module#MessagesModule'
          },
          {
            path: 'settings',
            loadChildren: 'app/pages/import-template/import-template.module#ImportTemplateModule'
          },
          {
            path: 'settings',
            loadChildren: 'app/pages/import-settings/import-settings.module#ImportSettingsModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/users/users.module#UsersModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/note-template/note-template.module#NoteTemplateModule'
          },
         {
            path: 'system',
            loadChildren: 'app/pages/providers-type/providers-type.module#ProvidersTypeModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/companies/companies.module#CompaniesModule'
          }, {
            path: 'system',
            loadChildren: 'app/pages/providers/providers.module#ProvidersModule'
          }, {
            path: 'system',
            loadChildren: 'app/pages/actions/actions.module#ActionsModule',
          }, {
            path: 'system',
            loadChildren: 'app/pages/roles/roles.module#RolesModule'
          }, {
            path: 'system',
            loadChildren: 'app/pages/trip-locks/trip-locks.module#TripLocksModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/rules/rules.module#RulesModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/t-modules/t-modules.module#TModulesModule'
          },
          {
            path: 'system',
            loadChildren: 'app/pages/administration/security/user-productivity/user-productivity.module#UserProductivityModule'
          },
          {
            path: 'system/mobile-apps',
            loadChildren: 'app/pages/mobile-app/mobile-app.module#MobileAppModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/charges/charges.module#ChargesModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/credits/credits.module#CreditsModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/credits-type/credits-type.module#CreditsTypeModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/denial-reasons/denial-reasons.module#DenialReasonsModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/payor-types/payor-types.module#PayorTypesModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/payors/payors.module#PayorsModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/events/events.module#EventsModule'
          }, {
            path: 'billing',
            loadChildren: 'app/pages/t2-forms/t2-forms.module#T2FormsModule'
          },
          {
            path: 'billing',
            loadChildren: 'app/pages/bank/bank.module#BankModule'
          },
          {
            path: 'billing',
            loadChildren: 'app/pages/cancel-reasons/cancel-reasons.module#CancelReasonsModule'
          },
          {
            path: 'billing',
            loadChildren: 'app/pages/billing-schedules/billing-schedules.module#BillingSchedulesModule'
          },
          {
            path: 'billing',
            loadChildren: 'app/pages/companies-rescuenet/companies-rescuenet.module#CompaniesRescuenetModule'
          },
          {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/facilities/facilities.module#FacilitiesModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/facilities-types/facilities-types.module#FacilitiesTypesModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/call-types/call-types.module#CallTypesModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/time-rules/time-rules.module#TimeRulesModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/modifiers/modifiers.module#ModifiersModule'
          }, {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/vehicles-types/vehicles-types.module#VehiclesTypesModule'
          }, {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/vehicles/vehicles.module#VehiclesModule'
          }, {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/drivers/drivers.module#DriversModule'
          }, {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/on-demand-drivers/on-demand-drivers.module#OnDemandDriversModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/zip-code-florida/zip-code-florida.module#ZipCodeFloridaModule'
          }, {
            path: 'facilitiesAndAgencies',
            loadChildren: 'app/pages/region/region.module#RegionModule'
          },
          {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/quiz/quiz.module#QuizModule'
          },
          {
             path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/drivers-license/drivers-license.module#DriversLicenseModule'
          },
          {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/vehicle-inspection/vehicle-inspection.module#VehicleInspectionModule'
          },
          {
            path: 'vehiclesAndDrivers/qualifications',
            loadChildren: 'app/pages/qualifications/qualifications.module#QualificationsModule'
          },
          {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/licenses/licenses.module#LicensesModule'
          },
          {
            path: 'vehiclesAndDrivers',
            loadChildren: 'app/pages/posts/posts.module#PostsModule'
          }

        ]
      },
      {
        path: 'dispatch',
        data: {
          preload: true
        },
        children: [
          {
            path: '',
            loadChildren: 'app/pages/auto-routing-results/auto-routing-results.module#AutoRoutingResultsModule'
          },
          {
            path: '',
            loadChildren: 'app/pages/dispatch/dispatch.module#DispatchModule'
          }, {
            path: '',
            loadChildren: 'app/pages/schedule/schedule.module#ScheduleModule'
          }, {
            path: '',
            loadChildren: 'app/pages/providers-assignments/providers-assignments.module#ProvidersAssignmentsModule'
          }, {
            path: '',
            loadChildren: 'app/pages/dispatch-histories/dispatch-histories.module#DispatchHistoriesModule'
          }, {
            path: '',
            loadChildren: 'app/pages/trip-confirms/trip-confirms.module#TripConfirmsModule'
          }, {
            path: '',
            loadChildren: 'app/pages/A2-utils/provider-map/provider-map.module#ProviderMapModule'
          }, {
            path: '',
            loadChildren: 'app/pages/driver-schedule/driver-schedule.module#DriverScheduleModule'
          }
        ]
      },
      {
        path: 'fax',
        loadChildren: 'app/pages/faxes/faxes.module#FaxesModule'
      }, {
        path: '',
        loadChildren: 'app/pages/trip-reservations/trip-reservations.module#TripReservationsModule'
      }, {
        path: '',
        loadChildren: 'app/pages/marketings/marketings.module#MarketingsModule'
      }, {
        path: '',
        loadChildren: 'app/pages/payrolls/payrolls.module#PayrollsModule'
      }, {
      path: '',
        loadChildren: 'app/pages/payrolls-claims/payrolls-claims.module#PayrollsClaimsModule'
      },
      {
        path: '',
        loadChildren: 'app/pages/import-payments/import-payments.module#ImportPaymentsModule'
      },
      {
        path: 'billingmodule',
        loadChildren: 'app/pages/billings/billings.module#BillingsModule'
      },
      {
        path: 'Reporting',
        loadChildren: 'app/pages/data-processing/data-processing.module#DataProcessingModule'
      },
      {
        path: 'client',
        loadChildren: 'app/pages/clients/clients.module#ClientsModule'
      },
      {
        path: '',
        loadChildren: 'app/pages/merge-account/merge-account.module#MergeAccountModule'
      },
      {
        path: '',
        loadChildren: 'app/pages/reports/reports.module#ReportsModule'
      },
      {
        path: '',
        loadChildren: 'app/pages/ttech-errors/ttech-errors.module#TTechErrorsModule'
      },
    ]
  },
  {
    path: 'liveMap',
    loadChildren: 'app/pages/A2-utils/live-map/live-map.module#LiveMapModule'
  },
  {
    path: 'LiveMapDispatch',
    loadChildren: 'app/pages/A2-utils/live-map-dispatch/live-map-dispatch.module#LiveMapDispatchModule'
  },
  {
    path: 'SchedulePlanner',
    loadChildren: 'app/pages/auto-scheduler/auto-scheduler.module#AutoSchedulerModule'
  },
  {
    path: '**',
    redirectTo: 'auth/login'
  }];

const config: ExtraOptions = {
  useHash: true,
  enableTracing: false,
  preloadingStrategy: CustomPreloadingService
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, config),
    DebugerAppModule,
    LicensesModule,
    EscalationsModule,
    AdministrationModule,
    CountyModule,
    CustomValidatorsModule,
    PagesRoutingModule,
    ProvidersBillingModule,
    BillingProviderModule,
    ExternalBillingModule,
    AutoroutingModule,
    BillingGeneralModule,
    DashboardClaimsModule,
    ManagerReportsModule,
    DriverScheduleModule,
    StandingOrderModule,
    PopupDriverScheduleModule,
    TrackerModule,
    ComplaintsModule,
    DashboardProvidersModule,
    QuizModule,
    ZipCodeFloridaModule,
    DashboardProvidersExternalModule,
    CompaniesRescuenetModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts